import PropTypes from 'prop-types';
import React, { useContext } from 'react';

import { CustomIconContext } from 'context/CustomIconContext';
import { ICON_TYPES } from 'enums/configuration';
import overrideStyle from 'lib/overrideStyle';

const IconWrapper = overrideStyle('div')`
  align-items: center;
  display: flex;
  height: ${p => (p.height ? p.height : '14px')};
  justify-content: center;
  width: ${p => (p.width ? p.width : '14px')};
  svg {
    cursor: pointer;
    height: ${p => (p.height ? p.height : '14px')};
    width: ${p => (p.width ? p.width : '14px')};
  }
`;

export default function CustomIcon({ type }) {
  const icons = useContext(CustomIconContext);
  const svg = icons[type];
  let props = {};

  // single special case for external links to be wider
  if (type === ICON_TYPES.EXTERNAL_LINK) {
    props.width = '19px';
  }

  return <IconWrapper {...props} dangerouslySetInnerHTML={{ __html: svg }} />;
}

CustomIcon.propTypes = {
  type: PropTypes.oneOf(Object.values(ICON_TYPES)),
};
